import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-visualizator",
  templateUrl: "./visualizator.component.html",
  styleUrls: ["./visualizator.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class VisualizatorComponent {
  @Input() url;
  public iframeLoaded = false;
  constructor() {}
}
